/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 02.06.17.
 */

import PropTypes from "prop-types";
import _ from "underscore";

import BaseContainer from "../../containers/BaseContainer";
import {getStore} from "../../services/Dynamic";
import SchemaRegistry from "../../services/SchemaRegistry";
import {LocaleStore} from "../../services/Locale";
import {NotFoundException} from "../../Exceptions";
import {NotificationActions} from '../../services/Notification';
import Navigation from "../../Navigation";
import {SessionActions, SessionStore} from "../../services/Session/index";

/**
 * @typedef {object} BaseResourceContainerState
 * @property {BaseRestStoreState} resource
 * @property {LocaleStoreState} locale
 * @property {boolean} isLoading
 */

/**
 * @extends BaseContainer
 */
class BaseResourceContainer extends BaseContainer {
    static propTypes = {
        params: PropTypes.shape({
            resource: PropTypes.string.isRequired
        }).isRequired
    };

    static defaultProps = {};

    static storeMap = {
        resource: "resource",
        locale: LocaleStore
    };

    /**
     * @name BaseResourceContainer#state
     * @type BaseResourceContainerState
     */

    /**
     *
     * @param {object} props
     * @param {object} storeMap
     */
    constructor(props, storeMap = null) {
        super(props, (storeMap ? _.extend({}, BaseResourceContainer.storeMap, storeMap) : BaseResourceContainer.storeMap));
    }

    getResourceName(props, store) {
        if (props.params) return props.params[store];
        return null;
    }

    getStoreByName(props, name) {
        let resource = this.getResourceName(props, name);
        if (!resource) return null;
        if (!SchemaRegistry.getJsonSchema(resource, 'view')) throw new NotFoundException();
        return getStore(resource, this.getStoreName(resource));
    }

    getStoreName(resource) {
        return resource;
    }

    componentWillReceiveProps(nextProps) {
        if (this.isStoreChanged(nextProps)) {
            this.reloadStores(nextProps);
        }
    }

    isStoreChanged(nextProps) {
        for (let s of Object.keys(this.storeMap)) {
            if (_.isString(this.storeMap[s]) &&
                (this.getResourceName(nextProps, this.storeMap[s]) !== this.getResourceName(this.props, this.storeMap[s]))) {
                return true;
            }
        }
        return false;
    }

    reloadStores(props) {
        this.unloadStores();
        this.loadStores(props);
        this.listenStores();
    }

    /**
     * Called when specified store fails to load data.
     * By default this method uses notification to display error.
     * @param key Store key
     * @param {BaseRestStoreState} newState Store new state
     * @param {BaseRestStoreState} oldState Store old state
     */
    loadingFailed(key, newState, oldState) {
        switch (newState.action.error.code) {
            case 401:
                // Authentication error. Redirect to login page
                NotificationActions.actionError.defer(newState.action);
                SessionActions.sessionExpired.defer();
                break;
            case 403:
                // Access forbidden. On our case this can mean that user should first change the password.
                // Password change detection is implemented in main page!
                // No break intentionally!
            default:
                NotificationActions.actionError.defer(newState.action);
                break;
        }
    }

    /**
     * Returns actions object
     * @protected
     * @returns {BaseRestActions}
     */
    actions(key=null) {
        if (!key) key = "resource";
        return super.actions(key);
    }
}

export default BaseResourceContainer;
